// extracted by mini-css-extract-plugin
export default {"input":"viewPlans_input__np95b","removePrice":"viewPlans_removePrice__8ePJ8","settingBtn":"viewPlans_settingBtn__vdyha"};